// extracted by mini-css-extract-plugin
module.exports = {"container":"promoMatchOdds__container___B3qVL","odd":"promoMatchOdds__odd___3caWe","odd-name":"promoMatchOdds__odd-name___1tGws","vs":"promoMatchOdds__vs___3I_EV"};